import { Routes } from '@angular/router';
import { RoutesGuard } from './app.routes-guard';
import { AddCustomerComponent } from './customer/add-customer/add-customer.component';
import { UpdateCustomerComponent } from './customer/update-customer/update-customer.component';
import { ViewCustomersComponent } from './customer/view-customers/view-customers.component';
import { AddDealerRepComponent } from './dealer-rep/add-dealer-rep/add-dealer-rep.component';
import { UpdateDealerRepComponent } from './dealer-rep/update-dealer-rep/update-dealer-rep.component';
import { ViewDealerRepsComponent } from './dealer-rep/view-dealer-reps/view-dealer-reps.component';
import { AddDealerComponent } from './dealer/add-dealer/add-dealer.component';
import { UpdateDealerComponent } from './dealer/update-dealer/update-dealer.component';
import { ViewDealersComponent } from './dealer/view-dealers/view-dealers.component';
import { AddDroneComponent } from './drone/add-drone/add-drone.component';
import { TransferDroneComponent } from './drone/transfer-drone/transfer-drone.component';
import { UpdateDroneComponent } from './drone/update-drone/update-drone.component';
import { ViewDronesComponent } from './drone/view-drones/view-drones.component';
import { AddEmployeeComponent } from './employee/add-employee/add-employee.component';
import { UpdateEmployeeComponent } from './employee/update-employee/update-employee.component';
import { ViewEmployeesComponent } from './employee/view-employees/view-employees.component';
import { ErrorComponent } from './error/error.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { UploadLogComponent } from './logs/upload-log/upload-log.component';
import { ViewLogsComponent } from './logs/view-logs/view-logs.component';
import { MissionPlannerComponent } from './mission-planner/mission-planner.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PdfViewerComponent } from './pdf-viewer/pdf-viewer.component';
import { PendingVerificationComponent } from './pending-verification/pending-verification.component';
import { UnknownAccountComponent } from './unknown-user/unknown-user.component';
import { ViewFirmwareComponent } from './firmware/view-firmware/view-firmware.component';

export const routes: Routes = [
    { path: "login", component: LoginComponent },
    { path: "home", component: HomeComponent, canActivate: [RoutesGuard] },
    { path: "view-employees", component: ViewEmployeesComponent, canActivate: [RoutesGuard] },
    { path: "add-employee", component: AddEmployeeComponent, canActivate: [RoutesGuard] },
    { path: "update-employee/:id", component: UpdateEmployeeComponent, canActivate: [RoutesGuard] },
    { path: "view-dealers", component: ViewDealersComponent, canActivate: [RoutesGuard] },
    { path: "add-dealer", component: AddDealerComponent, canActivate: [RoutesGuard] },
    { path: "update-dealer/:id", component: UpdateDealerComponent, canActivate: [RoutesGuard] },
    { path: "view-dealer-reps", component: ViewDealerRepsComponent, canActivate: [RoutesGuard] },
    { path: "add-dealer-rep", component: AddDealerRepComponent, canActivate: [RoutesGuard] },
    { path: "update-dealer-rep/:id", component: UpdateDealerRepComponent, canActivate: [RoutesGuard] },
    { path: "view-customers", component: ViewCustomersComponent, canActivate: [RoutesGuard] },
    { path: "add-customer", component: AddCustomerComponent, canActivate: [RoutesGuard] },
    { path: "update-customer/:id", component: UpdateCustomerComponent, canActivate: [RoutesGuard] },
    { path: "view-drones", component: ViewDronesComponent, canActivate: [RoutesGuard] },
    { path: "add-drone", component: AddDroneComponent, canActivate: [RoutesGuard] },
    { path: "update-drone/:id", component: UpdateDroneComponent, canActivate: [RoutesGuard] },
    { path: "transfer-drone/:id", component: TransferDroneComponent, canActivate: [RoutesGuard] },
    { path: "mission-planner", component: MissionPlannerComponent, canActivate: [RoutesGuard] },
    { path: "view-firmware/:vehicle/:model", component: ViewFirmwareComponent, canActivate: [RoutesGuard] },
    { path: "view-pdf/:category/:name", component: PdfViewerComponent, canActivate: [RoutesGuard] },
    { path: "upload-log-files", component: UploadLogComponent, canActivate: [RoutesGuard] },
    { path: "view-log-files", component: ViewLogsComponent, canActivate: [RoutesGuard] },
    { path: "unknown", component: UnknownAccountComponent, canActivate: [RoutesGuard] },
    { path: "pending-verification", component: PendingVerificationComponent, canActivate: [RoutesGuard] },
    { path: "error", component: ErrorComponent, canActivate: [RoutesGuard] },
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: '**', component: PageNotFoundComponent },
];
